import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { TreeSelect } from 'antd';
import { TreeNode } from 'antd/lib/tree-select';
import { VertexTreeSelectProps, TreeSelectData } from './TreeSelectProps.interface';
import 'antd/dist/antd.css';
import './tree-select.scss';

const VertexTreeSelect = ({
  treeData,
  value,
  treeDefaultExpandAll,
  placeholder,
  onChange,
  showSearch = false,
  visibleItems = 15,
}: VertexTreeSelectProps): JSX.Element => {
  Logging.Debug('TreeSelect', treeData);

  // Render the Tree Data
  const renderData = (data: TreeSelectData[]): JSX.Element[] => { // eslint-disable-line arrow-body-style
    if (data) {
      return data.map((item: TreeSelectData) => { // eslint-disable-line arrow-body-style
        return (
          <TreeNode key={item.value} value={item.value} title={item.title}>
            {renderData(item.children)}
          </TreeNode>
        );
      });
    }

    return null;
  };

  // Multiples of 32px
  const listHeight = visibleItems * 32;

  return (
    <TreeSelect
      showSearch={showSearch}
      style={{ width: '100%' }}
      value={value}
      // dropdownStyle={{ maxHeight: 600, overflow: 'auto' }}
      placeholder={placeholder}
      allowClear
      treeDefaultExpandAll={treeDefaultExpandAll}
      onChange={onChange}
      listHeight={listHeight}
    >
      {renderData(treeData)}
    </TreeSelect>
  );
};

export default VertexTreeSelect;
